export default ({ fiberCount, plugType, plex }) => {
  if (!fiberCount || !plex || !plugType) return null;

  const sxPlugs = [
    "LC",
    "SC",
    "FC",
    "E2000",
    "ST",
    "FC Narrow Key",
    "FSMA 905 Rändel",
    "DIN",
    "",
  ];
  const dxPlugs = [
    "LC",
    "SC",
    "E2000",
    "URM NG P2",
    "MDC",
    "CS",
    "SN EZ-Flip",
  ];
  const mtpPlugs = ["MTP", "MTP12", "mtp", "mtp12"];
  const mtp24Plugs = ["MTP24", "mtp24"];

  // eslint-disable-next-line
  // console.log({ fiberCount, plugType, plex })

  // actually throw, not combinable
  if (fiberCount === "1" && plex !== "sx") return null;
  if (fiberCount === "2" && plex === "dx") return null;

  if (fiberCount === "2" && plex === "sx") return null;
  if (fiberCount === "2" && plex === "dx") return null;

  if (fiberCount === "2x1" && plex === "sx") return 2;
  if (fiberCount === "2x1" && plex === "dx") return 1;
  if (fiberCount === "2x1" && plex.indexOf("Uniboot")) return null;
  // if (fiberCount === '2x1' && plugType === 'URM NG P2') return null
  // if (fiberCount === '2x1' && plugType === 'URM NG P8') return null
// fiberCount = 4, 8, 12, 24
  if (fiberCount.indexOf("x") === -1 && !isNaN(fiberCount)) {
    // eslint-disable-next-line
    let fiberCountNumber = parseInt(fiberCount);
    // console.log({fiberCount, plugType, plex, fiberCountNumber})
    if (plex === "sx" && sxPlugs.includes(plugType)) return fiberCountNumber;
    if (plex === "dx" && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (plex.indexOf("Uniboot") >= 0 && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (plex === "SN EZ-Flip" && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (
      plugType === "URM NG P2" &&
      fiberCountNumber >= 2 &&
      fiberCountNumber % 2 === 0
    )
      return fiberCountNumber / 2;

    if (
      plugType === "MDC" &&
      fiberCountNumber >= 2 &&
      fiberCountNumber % 2 === 0
    )
      return fiberCountNumber / 2;
    if (mtpPlugs.includes(plugType) && fiberCountNumber >= 12 && fiberCountNumber % 12 === 0)
      return 1;
    if (mtp24Plugs.includes(plugType) && fiberCountNumber >= 24 && fiberCountNumber % 24 === 0)
      return 1;
    if (plugType === "URM NG P8" && fiberCountNumber < 8) return null;
    if (
      plugType === "URM NG P8" &&
      fiberCountNumber % 8 === 0 &&
      fiberCountNumber !== 24
    )
      return fiberCountNumber / 8;
    if (plugType === "URM NG P8" && fiberCountNumber % 8 !== 0)
      return parseInt(fiberCountNumber / 8);
  }

  // fiberCount = 4x8, 6x8, 8x8, 12x8
  if (
    fiberCount.indexOf("x8") >= 1 &&
    !isNaN(fiberCount.split("x")[0]) &&
    !isNaN(fiberCount.split("x")[1])
  ) {
    // eslint-disable-next-line
    let fiberCountNumber =
      parseInt(fiberCount.split("x")[0]) * parseInt(fiberCount.split("x")[1]);
    // console.log({fiberCount, plugType, plex, fiberCountNumber})
    if (plex === "sx" && sxPlugs.includes(plugType)) return fiberCountNumber;
    if (plex === "dx" && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (plex.indexOf("Uniboot") >= 0 && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (plex.indexOf("MDC") >= 0 && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (plex === "SN EZ-Flip" && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (
      plugType === "URM NG P2" &&
      fiberCountNumber >= 2 &&
      fiberCountNumber % 2 === 0
    )
      return fiberCountNumber / 2;
    if (plugType === "URM NG P8" && fiberCountNumber < 8) return null;
    if (plugType === "URM NG P8" && fiberCountNumber % 8 === 0)
      return fiberCountNumber / 8;
    if (plugType === "URM NG P8" && fiberCountNumber % 8 !== 0) return null;
  }

  if (
    fiberCount.indexOf("x12") >= 1 &&
    !isNaN(fiberCount.split("x")[0]) &&
    !isNaN(fiberCount.split("x")[1])
  ) {
    // eslint-disable-next-line
    let fiberCountNumber =
      parseInt(fiberCount.split("x")[0]) * parseInt(fiberCount.split("x")[1]);
    // console.log({fiberCount, plugType, plex, fiberCountNumber})
    if (plex === "sx" && sxPlugs.includes(plugType)) return fiberCountNumber;
    if (plex === "dx" && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (plex.indexOf("Uniboot") >= 0 && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (plex.indexOf("MDC") >= 0 && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (plex === "SN EZ-Flip" && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (
      plugType === "URM NG P2" &&
      fiberCountNumber >= 2 &&
      fiberCountNumber % 2 === 0
    )
      return fiberCountNumber / 2;
    if (plugType === "URM NG P8" && fiberCountNumber < 8) return null;
    if (plugType === "URM NG P8" && fiberCountNumber % 8 === 0)
      return parseInt(fiberCount.split("x")[0]);
  }

  if (
    fiberCount.indexOf("x2") >= 1 &&
    !isNaN(fiberCount.split("x")[0]) &&
    !isNaN(fiberCount.split("x")[1])
  ) {
    // eslint-disable-next-line
    let fiberCountNumber =
      parseInt(fiberCount.split("x")[0]) * parseInt(fiberCount.split("x")[1]);
    // console.log({fiberCount, plugType, plex, fiberCountNumber})
    if (plex === "sx" && sxPlugs.includes(plugType)) return fiberCountNumber;
    if (plex === "dx" && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (plex.indexOf("Uniboot") >= 0 && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (plex.indexOf("MDC") >= 0 && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (plex === "SN EZ-Flip" && dxPlugs.includes(plugType))
      return fiberCountNumber / 2;
    if (
      plugType === "URM NG P2" &&
      fiberCountNumber >= 2 &&
      fiberCountNumber % 2 === 0
    )
      return fiberCountNumber / 2;
    // if (plugType === 'URM NG P8' && fiberCountNumber < 8) return null
    // if (plugType === 'URM NG P8' && fiberCountNumber % 8 === 0) return parseInt(fiberCount.split('x')[0])
  }

  if (fiberCount === "2" && plugType === "URM NG P2") return 1;
  if (fiberCount === "2" && plex.indexOf("Uniboot") === 0) return 1;
  if (fiberCount === "2" && plex.indexOf("MDC") === 0) return 1;
  if (fiberCount === "2" && plex === "SN EZ-Flip") return 1;
  return null;
};
